import axios from 'axios';
import FetchMainCode from '../ClientProblemRouter/fetchMainCode';
import { saveUserSubmission, addProblemToSolved } from '../Firebase/FireStore';
import { gradeResponseWithRegex } from './gradeResponse';
import { auth } from '../Firebase/InitFirebase';
import { getProblemById } from '../Data/ProblemsMethod';
import { type } from '@testing-library/user-event/dist/type';


function passedAllTestCases(responseJSON){
    const response_array = responseJSON?.data?.submissions
    for(let i = 0; i < response_array.length; i++) 
        if(response_array[i].status.description !== "Accepted") 
            return false;
    return true;
}



  
export const batchedSubmission = async (problemID, userID, IDEText, LanguageID) => {
   

    console.log("LangID type in Judge0: ", typeof LanguageID)

    
    // Build Request JSON to send to Judge0
    let requestJSON =  {};
    requestJSON.submissions = [];
    const currProblem = getProblemById(problemID);
    const numTestCases = currProblem.input.length;
    const mainCode = await FetchMainCode(problemID, LanguageID)
    for(let i = 0; i < numTestCases; i++){
        let singleTestCase =  {}
        singleTestCase.language_id = LanguageID;
       
        singleTestCase.source_code = IDEText + "\n\n" + mainCode;
        singleTestCase.stdin = currProblem.input[i]
        singleTestCase.expected_output = currProblem.expected_output[i]
        requestJSON.submissions.push(singleTestCase);
    }



    // This is the URL of the firebase function that hosts the Judge 0 call 
    const url = "https://us-central1-xxxaoxxx-5a5eb.cloudfunctions.net/judgezero"
    const body = requestJSON;
  
    const idToken = await auth.currentUser.getIdToken(true); // https://stackoverflow.com/questions/42751074/how-to-protect-firebase-cloud-function-http-endpoint-to-allow-only-firebase-auth
    try{


        // console.log("--- Firebase Call Body ---")
        // console.log(body)
        // console.log("---------------------------")
        let responseJSON;
        try{
            responseJSON = await axios.post(url, body, {
                headers: { "Content-Type": "application/json",
                Authorization: `Bearer ${idToken}`
            }
            });
        } catch(err){
            console.log("[ERROR] Hitting Judge0 cloud function: ", err )
        }
       
        

        // console.log("--- Firebase Call Response ---")
        // console.log(responseJSON); 
        // console.log("---------------------------")
        

        if(responseJSON.status == 409){
            return {
                "data": {
                  "submissions": [
                    {
                      "compile_output": null,
                      "stderr": "You have made 100 submissions this month already, subscribe to unlock more."
                    }
                  ]
                }
              } 
        }

        if(responseJSON.status !== 200){
          return {
            "data": {
              "submissions": [
                {
                  "compile_output": null,
                  "stderr": "Error executing code, bad status code."
                }
              ]
            }
          }
        }
        // console.log("--- Firebase Call Response ---")
        // console.log(responseJSON); 
        // console.log("---------------------------")
        
        gradeResponseWithRegex(responseJSON, problemID);
        const passedProblem = passedAllTestCases(responseJSON);

        if(passedProblem){
            try{
                addProblemToSolved(problemID);
            }
            catch(err){
                console.log("error adding problem to solved db", err)

                // return {
                //     "data": {
                //       "submissions": [
                //         {
                //           "compile_output": null,
                //           "stderr": "Error adding problem to solved"
                //         }
                //       ]
                //     }
                //   }
            }
        }


        try{
            await saveUserSubmission(problemID, userID, IDEText, LanguageID, passedProblem)
         } catch(error){
            console.log("[DB ERROR] ", error)
            // return {
            //      "data": {
            //        "submissions": [
            //          {
            //            "compile_output": null,
            //            "stderr": "Error saving code submission to database"
            //          }
            //        ]
            //      }
            //    }
         }

        return responseJSON;  
    } catch{
        return {};
    }
}